import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

/**
 * Guard for admin screens whose API is SuperAdmin-only (Issue Triage, Error Analytics).
 *
 * `AdminRoute` admits Admin and Ops too, so without this an Admin or Ops user who typed the address would reach
 * a page whose every request is refused. Same rule as the API (`requireRole('SuperAdmin')`): the isSuperAdmin
 * flag OR a role named SuperAdmin.
 */
export function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isSuperAdmin, getPrimaryRole } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!(isSuperAdmin || getPrimaryRole() === 'SuperAdmin')) {
    return (
      <div className="p-8 text-center" role="alert">
        <h1 className="text-lg font-semibold text-sage-800">You do not have access to this page</h1>
        <p className="text-sm text-sage-600 mt-2">This screen is limited to Super Administrators.</p>
      </div>
    );
  }

  return <>{children}</>;
}
